module.exports = __webpack_public_path__ + "img/cdq2a32-50dm-j79--__-1855.prt.e7a1d9c1.jpg";